import React from "react";
import { useTranslation } from "react-i18next";
import { FormikProps } from "formik";
import { useMyTimesheetCostList } from "my-timesheet/hooks";
import { OcFormEditorItemList } from "oc/components";
import { useOcFormEditorSelector } from "oc/hooks";

interface MyTimesheetCostSelectorProps {
  formik: FormikProps<any>;
}

export const MyTimesheetCostSelector = ({
  formik,
}: MyTimesheetCostSelectorProps) => {
  const { t } = useTranslation();

  const { data: costsData } = useMyTimesheetCostList({
    page: 1,
    pageSize: 100,
    sort: "name",
    sortDirection: "asc",
    searchField: "",
    searchText: "",
  });

  const {
    list: costList,
    search: costSearch,
    selectedItem: selectedCost,
    handleSearch: handleCostSearch,
    handleClearSearch: handleCostClearSearch,
    handleHasMore: handleCostHasMore,
  } = useOcFormEditorSelector({
    value: formik.values.costId,
    list:
      costsData?.rows?.map((item) => ({
        code: item.code,
        name: item.name,
        validTo: item.validTo
      })) || [],
  });

  const handleChange = (value: string | number) => {
    formik.setFieldValue("costId", value);
  };

  return (
    <OcFormEditorItemList
      key={"cost"}
      value={selectedCost}
      list={costList}
      label={t("OC_COST")}
      search={costSearch}
      onSearch={handleCostSearch}
      onChange={(type, value) => {
        handleChange(value);
      }}
      onClearSearch={handleCostClearSearch}
      onScroll={handleCostHasMore}
      name={"cost"}
      error={false}
      module="MyTimesheet"
    />
  );
};

export default MyTimesheetCostSelector;
